@if (products()) {
<div class="component-column">
  @if (member()?.IsLoggedIn) {
  <div>Account balance is <span>{{member()?.AvailableBalance?.AmountFormatted}}</span></div>
  }
  @for (productTypeId of productTypes; track productTypeId; let i = $index) {<!--Loop through product types-->
  <div class="component-panel">
    <div>
      <h4>
        @if(isProductBundleSession(productTypeId)){<!--Bundle session product type header-->
        Pre-Pay {{resources?.reading}}
        }@else if(isProductPaygSession(productTypeId)){<!--Pay as you go session product type header-->
        Pay as you Go {{resources?.reading}}
        }@else if(isProductMinutesTopUp(productTypeId)){<!--Minutes account topup product type header-->
        Top up account minutes
        }@else if(isProductGeneralTopUp(productTypeId)){<!--Currency account topup product type header-->
        Top up account balance
        }@else{<!--Fallback - shouldn't be used-->
        Top up
        }
      </h4>
    </div>
    @for (product of filterProductsByTypeId(products(), productTypeId); track product?.ProductId; let j = $index) {<!--Loop through products of current type-->
    <div>
      <a tabindex="0" class="component-button button-available" (click)="selectProduct(product)">
        <span>
          @if (isProductOnlineChat(productTypeId))
          {
          <i><svg><use href="#icon-chats"></use></svg></i>
          }@else{
          <i><svg><use href="#icon-phone"></use></svg></i>
          }
        </span>
        <span>
          @if(isProductBundleSession(productTypeId)){<!--Bundle session product-->
          @if(productActionStart()){
          Start {{product?.Minutes}} minute {{resources?.reading}}
          }@else{
          Buy {{product?.Minutes}} minute {{resources?.reading}}
          }
          }@else if(isProductPaygSession(productTypeId)){<!--Pay as you go session product-->
          @if(productActionStart()){
          Start Pay as you Go {{resources?.reading}}
          }@else{
          Buy Pay as you Go {{resources?.reading}}
          }
          }@else if(isProductMinutesTopUp(productTypeId)){<!--Minutes account topup product-->
          Buy {{product?.Minutes}} minutes for {{product?.Price?.AmountFormatted}}
          }@else if(isProductGeneralTopUp(productTypeId)){<!--Currency account topup product-->
          Buy {{product?.Price?.AmountFormatted}} top up
          }@else{<!--Fallback - shouldn't be used-->
          Top up {{product?.Price?.AmountFormatted}}
          }
        </span>
      </a>
    </div>
    @if(isProductBundleSession(productTypeId)){<!--Bundle session product footer-->
    <div>
      <p>
        <span class="nowrap">{{product?.PriceStandard?.AmountFormatted}} for {{product?.Minutes}} minutes</span>
        &ngsp;
        <span class="nowrap">({{product?.PricePerMinuteStandard?.AmountFormatted}}/min)</span>
      </p>
    </div>
    }@else if(isProductPaygSession(productTypeId)){<!--PAYG session product footer-->
    <div>
      <p><span class="nowrap">Pay as you Go ({{product?.PricePerMinuteStandard?.AmountFormatted}}/min)</span></p>
    </div>
    }@else if(isProductMinutesTopUp(productTypeId)){<!--Minutes account topup product footer-->
    <div>
      <p>
        <span class="nowrap">{{product?.Price?.AmountFormatted}} for {{product?.Minutes}} minutes</span>
      </p>
    </div>
    }@else if(isProductGeneralTopUp(productTypeId)){<!--Currency account topup product footer-->
    <div>
      <p><span class="nowrap">{{product?.Price?.AmountFormatted}} topup</span></p>
    </div>
    }
    }
    @if(isProductPaygSession(productTypeId)){<!--Pay as you go session product type footer-->
    <div>
      <div class="smallprint">
        <p>
          @if (member()?.IsLoggedIn) {
          <span class="nowrap">{{availableMinutesForProduct(paygProduct())}} minutes available.</span>&ngsp;
          @if(isProductTypeIvr(productTypeId)) {
          @if(config().IvrPaygMinimumMinutes){
          <span class="nowrap">Minimum {{config()?.IvrPaygMinimumMinutes}} minutes credit to start {{resources?.reading}}.</span>
          } @else {
          <span class="nowrap">Minimum balance to start {{resources?.reading}} {{config()?.CallbackMinimumCreditAllowed?.AmountFormatted}}.</span>
          }
          } @else {
          @if(config().ImPaygMinimumMinutes){
          <span class="nowrap">Minimum {{config()?.ImPaygMinimumMinutes}} minutes credit to start {{resources?.reading}}.</span>
          } @else {
          <span class="nowrap">Minimum balance to start {{resources?.reading}} {{config()?.OnlineChatPaygStartMinimumBalance?.AmountFormatted}}.</span>
          }
          }
          }
        </p>
      </div>
    </div>
    }
  </div>
  }
  </div>
}
